import Button from 'components/Button'

const Buttons = ({ data }) => {
  return (
    <div className="max-w-6xl mx-auto">
      <div className="mt-10 ml-12 mr-10 mb-20 lg:mr-20">
        <div className="mt-20 grid grid-cols-1 lg:flex flex-wrap gap-6">
          {data.map((item, idx) => (
            <Button
              key={idx}
              link={item.link}
              text={item.texto}
              textColorHex={item.color_texto}
              colorHex={item.color_fondo}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
export default Buttons
